import React, { Component } from 'react';

class CariMainPgFooterView extends Component {

    state = {
        beedieTracs: "Beedie TRACS",
    }
    render() {
        return (
            <div>
                <footer className="main_menu_powered_by_format">
                    <div className="center_footer_text">
                        {this.state.beedieTracs} | 
                        <a
                            href='http://www.sfu.ca/webmaster/terms.html' target='_blank'
                            rel="noopener noreferrer"
                        > Terms &amp; Privacy 
                        </a> | 
                        <a
                            href='mailto:"Beedie School of Business Appointments Secretary"<aacoord@sfu.ca>' target='_blank'
                            rel="noopener noreferrer"
                        > Contact Us - aacoord@sfu.ca
                        </a> | © Simon Fraser University
                    </div>
                </footer>
            </div>
        );
    }
}

export default CariMainPgFooterView;